// source: pbtypes/gen/subject_follower/subject_follower_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_subject_follower_subject_follow_mode_pb = require('../../../pbtypes/gen/subject_follower/subject_follow_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_subject_follower_subject_follow_mode_pb);
goog.exportSymbol('proto.subject_follower.SubjectFollowerSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.subject_follower.SubjectFollowerSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.subject_follower.SubjectFollowerSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.subject_follower.SubjectFollowerSettings.displayName = 'proto.subject_follower.SubjectFollowerSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.subject_follower.SubjectFollowerSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subject_follower.SubjectFollowerSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.subject_follower.SubjectFollowerSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
autoStartOnNewSubject: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
fixedElevation: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
followMode: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subject_follower.SubjectFollowerSettings}
 */
proto.subject_follower.SubjectFollowerSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.subject_follower.SubjectFollowerSettings;
  return proto.subject_follower.SubjectFollowerSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subject_follower.SubjectFollowerSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subject_follower.SubjectFollowerSettings}
 */
proto.subject_follower.SubjectFollowerSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoStartOnNewSubject(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFixedElevation(value);
      break;
    case 4:
      var value = /** @type {!proto.subject_follower.SubjectFollowMode.Enum} */ (reader.readEnum());
      msg.setFollowMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.subject_follower.SubjectFollowerSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subject_follower.SubjectFollowerSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.subject_follower.SubjectFollowerSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getAutoStartOnNewSubject();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFixedElevation();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFollowMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.subject_follower.SubjectFollowerSettings} returns this
 */
proto.subject_follower.SubjectFollowerSettings.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool auto_start_on_new_subject = 2;
 * @return {boolean}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.getAutoStartOnNewSubject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.subject_follower.SubjectFollowerSettings} returns this
 */
proto.subject_follower.SubjectFollowerSettings.prototype.setAutoStartOnNewSubject = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool fixed_elevation = 3;
 * @return {boolean}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.getFixedElevation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.subject_follower.SubjectFollowerSettings} returns this
 */
proto.subject_follower.SubjectFollowerSettings.prototype.setFixedElevation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional SubjectFollowMode.Enum follow_mode = 4;
 * @return {!proto.subject_follower.SubjectFollowMode.Enum}
 */
proto.subject_follower.SubjectFollowerSettings.prototype.getFollowMode = function() {
  return /** @type {!proto.subject_follower.SubjectFollowMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.subject_follower.SubjectFollowMode.Enum} value
 * @return {!proto.subject_follower.SubjectFollowerSettings} returns this
 */
proto.subject_follower.SubjectFollowerSettings.prototype.setFollowMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


goog.object.extend(exports, proto.subject_follower);
